import { render, staticRenderFns } from "./index.vue?vue&type=template&id=485bfd72&scoped=true&lang=html&"
import script from "./customDetail.js?vue&type=script&lang=js&"
export * from "./customDetail.js?vue&type=script&lang=js&"
import style0 from "./customDetail.styl?vue&type=style&index=0&id=485bfd72&lang=stylus&scoped=true&"
import style1 from "./resetStyle.styl?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485bfd72",
  null
  
)

export default component.exports